import {Component, ViewChild} from '@angular/core';
import {Response, Headers, RequestOptions, Http} from '@angular/http';
import {ApiClientService} from '../../../services/api-client.service';
import {ResidentForSelect} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {IncidentReportsService} from '../../../services/incident-reports.service';
import {DatePipe} from '@angular/common';
import {environment} from '../../../../environments/environment';
import {ConstantsService} from '../../../services/constants.service';
import {AuthTokenService} from '../../../services/auth-token.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'incident-report-detailed-view',
    templateUrl: './incident-report-detailed-view.component.html',
    styleUrls: ['./incident-report-detailed-view.component.scss']
})

export class IncidentReportDetailedViewComponent {
    @ViewChild('form') form;
    navPosition = 'info';
    comment = '';
    suites = [];
    residents = [];
    buildingSelectIsDisabled = false;
    maxDate = new Date();
    disabledFileInput = false;

    constructor(public api: ApiClientService,
                public incidentReportsService: IncidentReportsService,
                public directoryService: DirectoryService,
                public authenticationService: AuthenticationService,
                private http: Http,
                private authTokenService: AuthTokenService
    ) {}

    onSubmit(data: any): void {
        const url = `/v1/incident_report/${this.incidentReportsService.selectedItemData.id}.json`;
        this.incidentReportsService.api.patch('domainIncidentReports', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => this.api.errorHandler(error, 'Update failed!')
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.incidentReportsService.toggleDetailedView(this.incidentReportsService.selectedItemData, true);
        this.incidentReportsService.getData();
        if (close) this.incidentReportsService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean, form?) {
        if(!this.incidentReportsService.selectedItemData.isCanEdit)
            return;
        this.setEditModeForAll(false);
        if(fieldName != 'building' && fieldName != 'unit' && fieldName != 'resident') {
            item.formFields[fieldName].editMode = state;
            if(fieldName == 'incidentAt')
                setTimeout(() => this.initTimepicker(), 300);
        } else {
            if(state) {
                this.getSuites(this.incidentReportsService.selectedItemData.buildingId, this.incidentReportsService.selectedItemData.suiteId, form);
                if(this.incidentReportsService.selectedItemData.suiteId === 0)
                    this.residents.push(new ResidentForSelect(0, 'Other'));
            }
            item.formFields['building'].editMode = state;
            item.formFields['unit'].editMode = state;
            item.formFields['resident'].editMode = state;
        }
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.incidentReportsService.selectedItemData.formFields)
            this.incidentReportsService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        if (form.dirty) {
            if(formField != 'incidentAt')
                item[formField] = form.value[formField];
            if(formField == 'building' || formField == 'unit' || formField == 'resident') {
                if(!form.value.building ||
                   !(form.value.unit || (form.value.unit === 0 && form.value.otherSuite)) ||
                   !(form.value.resident || (form.value.resident === 0 && form.value.otherResident))) {
                    toastr.warning('All details about building, unit and resident must be filled to proceed.');
                    return;
                }
                const building = this.incidentReportsService.buildings.find((item) => +item.id === +form.value.building);
                const suite    = this.suites.find((item) => +item.id === +form.value.unit);
                const resident = this.residents.find((item) => +item.id === +form.value.resident);
                changedValue = {
                    building: {
                        bdId: form.value.building,
                        name: building ? building.name : null,
                        address: building ? building.address : null,
                        corporationNumberBd: building ? building.corporationNumber : null,
                        timezone: building ? (building.timeZone ? building.timeZone.value : null) : null
                    },
                    suite: {
                        bdId:        suite.id ? form.value.unit : 0,
                        suiteNumber: suite.id ? suite.name         : form.value.otherSuite,
                    },
                    resident: {
                        bdId:     resident.id ? resident.id       : 0,
                        fullName: resident.id ? resident.fullName : form.value.otherResident,
                        //Fixme: add resident email
                    },
                };
            } else if(formField == 'incidentAt') {
                if(!form.value.incidentAt || !form.value.startTime) {
                    toastr.warning('All Start Date details must be filled to proceed.');
                    return;
                }
                changedValue = {incidentAt: this.getDateTimeFromForm('incidentAt', 'startTime')};
            }
            this.onSubmit(changedValue);
            if (form.valid) this.setEditModeForAll(false);
        } else {
            this.setEditModeForAll(false);
        }
    }

    changeBuilding(buildingId: string, form) {
        form.controls['unit'].reset();
        form.controls['resident'].reset();
        this.getSuites(+buildingId, null, form);
    }

    getSuites(buildingId: number, suiteId?: number, form?): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                const suites = JSON.parse(res._body).entities || [];
                suites.forEach(suite => this.suites.push({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId, form);
                this.buildingSelectIsDisabled = false;
            },
            error => {
                this.buildingSelectIsDisabled = false;
                this.api.errorHandler(error, 'Failed get suites');
            }
        );
    }

    changeUnit(suiteId: string, form) {
        if(form.controls['resident'].value !== 0)
            form.controls['resident'].reset();
        this.getResidents(+suiteId, form);
        if (suiteId + '' === '0') {
            form.controls['resident'].setValue(0);
            setTimeout(() => {
                form.controls['otherSuite'].reset();
                form.controls['otherResident'].reset();
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }, 0);
        }
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    getResidents(suiteId: number, form): void {
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if(form.value.unit !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    this.residents = residents.map(
                        item => (new ResidentForSelect(item.id, item.fullName, [], item.email))
                    );
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    typeSelect(arr: Array<any>) {
        return arr.map(incidentReportType => ({value: incidentReportType.id, optionText: incidentReportType.name}));
    }

    sendIncidentReport(incident) {
        this.incidentReportsService.isSendIncidentReportModalShow = true;
        this.incidentReportsService.incidentReportInIncidentReportsModal = JSON.parse(JSON.stringify(incident));
    }

    openTimepicker(): void {
        $('#timepicker').timepicker('showWidget');
    }

    getTime(dateString) {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    getDateTimeFromForm(dateProperty, timeProperty): Date {
        const date = new Date(this.form.value[dateProperty]);
        const time = (<any>document.getElementsByName(timeProperty)[0]).value;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return moment(date).format('YYYY-MM-DD HH:mm');
    }

    initTimepicker() {
        $('#timepicker').timepicker().on('changeTime.timepicker', e => this.form.control.markAsDirty());
    }

    addFile(e) {
        const file = e.target.files[0];
        const fd   = new FormData();
        e.target.value = null;

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.disabledFileInput = true;
        this.http.post(`${environment.domainServiceRequest}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) { toastr.warning('Attachment path should not be blank.'); return; }
                const attachment = {name: file.name, fileSize: file.size, link: res.path, incidentReport: this.incidentReportsService.selectedItemData.id};
                this.patchFile(attachment);
            },
            error => this.api.errorHandler(error, 'Upload file failed'),
            () => this.disabledFileInput = false
        );
    }

    patchFile(attachment) {
        const url = '/v1/incident_report_attachment.json';
        this.incidentReportsService.api.post('domainIncidentReports', url, attachment).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => this.api.errorHandler(error, 'Update failed!')
        );
    }

    removeFile(index) {
        swal(
            ConstantsService.getSwalConfig('Delete Attachment'),
            () => {
                const url = `/v1/incident_report_attachment/${this.incidentReportsService.selectedItemData.attachments[index].id}`;
                this.incidentReportsService.api.remove('domainIncidentReports', url).subscribe(
                    () => this.updateView('The Field was successfully updated', false),
                    (error) => this.api.errorHandler(error, 'Update failed!')
                );
            }
        );
    }
    
}



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-report-detailed-view/incident-report-detailed-view.component.ts